import { render, staticRenderFns } from "./productCenTil.vue?vue&type=template&id=023625eb&scoped=true"
import script from "./productCenTil.vue?vue&type=script&lang=js"
export * from "./productCenTil.vue?vue&type=script&lang=js"
import style1 from "./productCenTil.vue?vue&type=style&index=1&id=023625eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023625eb",
  null
  
)

export default component.exports